/* tslint:disable */
/* eslint-disable */
/**
 * Consolidate Legacy API
 * No description provided (generated by Openapi Generator https://github.com/openapitools/openapi-generator)
 *
 * The version of the OpenAPI document: 1.0.0
 * 
 *
 * NOTE: This class is auto generated by OpenAPI Generator (https://openapi-generator.tech).
 * https://openapi-generator.tech
 * Do not edit the class manually.
 */

import { exists, mapValues } from '../runtime';
/**
 * 
 * @export
 * @interface GetContactItemAddress
 */
export interface GetContactItemAddress {
    /**
     * 
     * @type {string}
     * @memberof GetContactItemAddress
     */
    id: string;
    /**
     * 
     * @type {number}
     * @memberof GetContactItemAddress
     */
    icon: number;
    /**
     * 
     * @type {string}
     * @memberof GetContactItemAddress
     */
    anr: string;
    /**
     * 
     * @type {string}
     * @memberof GetContactItemAddress
     */
    city: string;
    /**
     * 
     * @type {string}
     * @memberof GetContactItemAddress
     */
    email?: string;
    /**
     * 
     * @type {string}
     * @memberof GetContactItemAddress
     */
    companyname: string;
    /**
     * 
     * @type {boolean}
     * @memberof GetContactItemAddress
     */
    isfavorite: boolean;
}

export function GetContactItemAddressFromJSON(json: any): GetContactItemAddress {
    return GetContactItemAddressFromJSONTyped(json, false);
}

export function GetContactItemAddressFromJSONTyped(json: any, ignoreDiscriminator: boolean): GetContactItemAddress {
    if ((json === undefined) || (json === null)) {
        return json;
    }
    return {
        
        'id': json['id'],
        'icon': json['icon'],
        'anr': json['anr'],
        'city': json['city'],
        'email': !exists(json, 'email') ? undefined : json['email'],
        'companyname': json['companyname'],
        'isfavorite': json['isfavorite'],
    };
}

export function GetContactItemAddressToJSON(value?: GetContactItemAddress | null): any {
    if (value === undefined) {
        return undefined;
    }
    if (value === null) {
        return null;
    }
    return {
        
        'id': value.id,
        'icon': value.icon,
        'anr': value.anr,
        'city': value.city,
        'email': value.email,
        'companyname': value.companyname,
        'isfavorite': value.isfavorite,
    };
}


